import { render, staticRenderFns } from "./createPayment.vue?vue&type=template&id=c704af6c"
import script from "./createPayment.vue?vue&type=script&lang=js"
export * from "./createPayment.vue?vue&type=script&lang=js"
import style0 from "./createPayment.vue?vue&type=style&index=0&id=c704af6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports